require(['jquery'],
    ($) => {

        'use strict';

        const handleQtyUpdate = (e, isIncrease) => {
            const $input = $(e.target).siblings('.product-qty-input');
            const value = parseInt($input.val());

            if (!isIncrease && value === 1) {
                return;
            }

            if (isIncrease) {
                $input.val(value + 1).trigger('change');
            }

            else {
                $input.val(value - 1).trigger('change');
            }
        };

        const addEvents = () => {
            $('.product-action-qty').on('click', '.qty-add', (e) => {
                handleQtyUpdate(e, true);
            });

            $('.product-action-qty').on('click', '.qty-substract', (e) => {
                handleQtyUpdate(e, false);
            });

            $('.product-qty-input').on('change', (e) => {
                const $input = $(e.target);
                $input.parent().siblings('[data-role="tocart-form"]').find('input[name="qty"]').val($input.val());
            });
        };

        const init = () => {
            addEvents();
        };

        init();

    });
